import { S3Image } from '../components/S3Image';
import { Card, Tooltip} from 'element-react';
import {toCurrency} from '../utils/FormatUtils';
import { useHistory } from "react-router-dom";
function ProductBox (props){
    console.log('KEY ::: ' + props.img);
    let history = useHistory();
    const goToProductView = () =>{
        history.push("/product-detail/"+props.id);
    }
    return(
        <div className="product-box cursor" onClick={goToProductView}>
            <Card className="product-card-instance" style={{ minHeight: '254px', maxWidth: '250px', display: 'flex', flexDirection: 'column', width: '100%' }}>
                <div className="product-image-container">
                    <S3Image
                        imgKey={props.img}
                        theme={{
                            photoImg: { width: "70px", height: "70px", maxWidth: "70px", maxHeight: "70px", objectFit: 'cover' }
                        }}
                        level="public"
                    />
                </div>
                {/* Nuevo contenedor flex para todo el texto */}
                <div className="product-text-content">
                    {/* clase para el nombre y añadir tooltip */}
                    <Tooltip
                        effect="dark" 
                        content={props.name} 
                        placement="bottom" 
                        trigger="click"
                    >
                        <p className="product-name-display">
                            {props.name} 
                        </p>
                    </Tooltip>
                    <div className="card-company-info">
                        by: &nbsp;<div className="card-company-title">{props.companyName}</div>
                    </div>
                    <div className="price-container">
                        <p className="price-ranges">{toCurrency(props.minPrice)} - {toCurrency(props.maxPrice)}</p>
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default ProductBox;
